import React from 'react'
import myImage from '../images/philipifeanyi.png'

const About = () => {
  return (
    <section id="about">
    <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
      <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
        <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
          Hey!!!, I'm Philip.<br></br>
          <br className="hidden lg:inline-block" />I love to build amazing web
          apps
        </h1>
        <p className="mb-8 leading-relaxed">
        I am a Full Stack Web Developer with 2+ years of experience building interactive web apps using technologies such as HTML, CSS, JavaScript, TailwindCSS/Bootstrap, React, Node.js, MongoDB, MySQL, and Git. I'm passionate about good design, solving problems, and making the web more usable for all.   
        </p>
        <p className="mb-8 leading-relaxed">
        I look at projects at a high level and think about where I can deliver the most value, whether that's in code or design.<br></br>
        I have hobbies such as teaching, soccer, tennis, and watching sci-fi movies.
        </p>
        <div className="flex justify-center">
          <a
            href="#contact"
            className="inline-flex text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg">
            Hire Me
          </a>
          <a
            href="#projects"
            className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg">
            View Projects
          </a>
        </div>
      </div>
      <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
        <img
          className="object-cover object-center rounded"
          alt="philip"
          src={myImage}
        />


      </div>
    </div>
  </section>
  )
}

export default About